export default "__VITE_ASSET__DFOhbP59__"